import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { routeAssignmentEventRefs } from "../subjects/routeAssignmentEvent/refs";

/**
 * The driver declined a route assignment.
 */
export const routeDeclinedV1 = tmsEventKind(
  { category: "routeAssignment", kind: "routeDeclined", version: 1 },
  {
    refs: routeAssignmentEventRefs,
    facts: {
      orderNumber: z.string(),
      /** The route assignment was declined as a team rather than by one driver. */
      isTeam: z.boolean(),
    },
  },
);

export const RouteDeclinedV1Schema = routeDeclinedV1.schema;
export const RouteDeclinedV1FactsSchema = routeDeclinedV1.facts;

export type RouteDeclinedV1 = z.infer<typeof RouteDeclinedV1Schema>;
export type RouteDeclinedV1Facts = z.infer<typeof RouteDeclinedV1FactsSchema>;

/** Every version of `routeDeclined`, keyed by version. What `catalog.ts` places under `routeAssignment`. */
export const routeDeclined = { 1: routeDeclinedV1 } as const;
